/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Link } from 'react-router';
import { useStyletron } from 'baseui';
import { Button } from '@letsdothis/lds/lib/Button';

import { useAuthService } from '@/contexts/authService';
import { logError } from '@/utils/logError';

import Field from '../../../Form/Fields/Field';

import * as styles from '../styles.module.css';
import FieldValidators from '../FieldValidators';
import { RecoverPasswordFormParams, RecoverPasswordParams } from './Types';
import {
  validateRecoverPasswordFormParams,
  validateRecoverPasswordParams,
} from './Validator';

const recoverPassword = async (
  authService: any,
  params: RecoverPasswordParams,
) => {
  validateRecoverPasswordParams(params);
  const { email, previousEmailError, setState } = params;

  const emailError = FieldValidators.validateEmail(email);
  if (emailError !== previousEmailError) {
    setState({ emailError });
  }

  if (!emailError) {
    await authService.recoverPassword({
      email,
    });
  } else {
    throw new Error('Validation Error on recover password');
  }
};

const RecoverPasswordForm = (
  params: RecoverPasswordFormParams,
): JSX.Element => {
  validateRecoverPasswordFormParams(params);
  const authService = useAuthService();
  const [css, theme] = useStyletron();
  const {
    email,
    emailError,
    recoverPasswordSuccess,
    setStage,
    setState,
    signInOrUpButtonLoading,
    signInOrUpError,
  } = params;
  const setEmail = (newEmail?: string) => setState({ email: newEmail });

  return (
    <div className={styles.emailPasswordContainer}>
      <h1>Enter Email to send Forgot Password Confirmation Code</h1>
      {Field({
        title: 'Email',
        value: email,
        setValue: setEmail,
        error: emailError,
      })}
      <Button
        disabled={recoverPasswordSuccess}
        isLoading={signInOrUpButtonLoading}
        onClick={() => {
          setState({ signInOrUpButtonLoading: true });
          setState({ signInOrUpError: undefined });
          recoverPassword(authService, {
            email,
            previousEmailError: emailError,
            setStage,
            setState,
          })
            .then(() => {
              setState({ signInOrUpButtonLoading: false });
              setState({ recoverPasswordSuccess: true });
            })
            .catch((error) => {
              setState({ signInOrUpButtonLoading: false });
              setState({
                signInOrUpError: 'Something went wrong.  Please try again.',
              });
              logError(error, {
                errorMessageFallback: 'Error while logging in.',
              });
            });
        }}
      >
        Recover password
      </Button>
      {signInOrUpError && (
        <div className={css({ color: theme.colors.negative400 })}>
          {signInOrUpError}
        </div>
      )}
      {recoverPasswordSuccess && (
        <div>An email has been sent to recover your password.</div>
      )}
      <div className={styles.terms}>
        By creating an account, you accept our <Link to="/terms">terms</Link>
      </div>
    </div>
  );
};

export default RecoverPasswordForm;
